const PRODUCT_SEARCH_ID = "productSearch";

const postKlevu = (cloudSearchUrl, body) =>
  fetch(`https://${cloudSearchUrl}/cs/v2/search/`, {
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    method: "POST",
    body: JSON.stringify(body),
  }).then((res) => res.json());

const withTypeOfSearch = (recordQuery, typeOfSearch) => ({
  ...recordQuery,
  settings: { ...recordQuery.settings, typeOfSearch },
});

// Klevu's default search falls back to fuzzy matching when a term has no exact
// match, so a partial SKU such as "cm1039" ranks one-character neighbours like
// CM1032 above CM1039X, which it is a prefix of. Wildcard search matches
// prefixes and returns the same results as the default for whole words, but
// finds nothing for misspellings, so only those fall back to the default.
export const klevuProductSearch = async (cloudSearchUrl, body) => {
  const productQuery = body.recordQueries.find(
    (query) => query.id === PRODUCT_SEARCH_ID
  );
  if (!productQuery) return postKlevu(cloudSearchUrl, body);

  const data = await postKlevu(cloudSearchUrl, {
    ...body,
    recordQueries: body.recordQueries.map((query) =>
      query === productQuery ? withTypeOfSearch(query, "WILDCARD_AND") : query
    ),
  });

  const index =
    data?.queryResults?.findIndex(
      (result) => result.id === PRODUCT_SEARCH_ID
    ) ?? -1;
  if (index === -1 || data.queryResults[index].meta?.totalResultsFound > 0)
    return data;

  const fallback = await postKlevu(cloudSearchUrl, {
    recordQueries: [productQuery],
    context: body.context,
  });
  if (fallback?.queryResults?.[0])
    data.queryResults[index] = fallback.queryResults[0];
  return data;
};
